<template>
    <v-layout row>
        <v-flex xs12 sm12>
            <v-card class="elevation-1 transparent">
                <v-toolbar class="transparent" flat height="37">
                    <v-btn dark icon title="Back to HR Menu" @click="$router.push('/hr')">
                        <v-icon>arrow_back</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                </v-toolbar>                
            </v-card>
            <v-card class="elevation-1 mt-5">
                <v-toolbar flat height="45px">
                    <div :class="isMobile?'wp-100 mb-10':'wp-50 mb-10'">
                        <v-text-field v-model="search" append-icon="search" :label="searchLabel" single-line hide-details clearable></v-text-field>
                    </div>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-progress-linear v-if="loading" color="primary" indeterminate height="2" class="mt-0"></v-progress-linear>
                <v-data-table
                    v-if="edocumentsFiltered.length"
                    :headers="[]"
                    :items="edocumentsFiltered"
                    :loading="loading"
                    :rows-per-page-items="rowsPerPageItems"
                    :pagination.sync="paginationSync"
                    hide-headers
                >  
                    <template v-slot:items="props">
                        <tr>
                            <td class="pa-1">
                                <v-card class="elevation-1" @click="preview(props.item)">
                                    <v-toolbar flat height="42">
                                        <v-icon v-if="isMobile" :color="getFileTypeIcon(props.item.fileType).color" class="mr-10">
                                            {{ getFileTypeIcon(props.item.fileType).icon }}
                                        </v-icon>
                                        <b class="underlined clickable">{{props.item.documentTitle}}</b>
                                        <v-spacer></v-spacer>
                                    </v-toolbar>
                                    <v-layout row wrap :class="isMobile?'section-layout-mobile':''">
                                        <v-flex v-if="!isMobile" xs12 sm4 class="text-xs-center clickable">
                                            <v-icon :color="getFileTypeIcon(props.item.fileType).color" size="150" class="mt-50" title="Click to preview the document">
                                                {{ getFileTypeIcon(props.item.fileType).icon }}
                                            </v-icon>
                                            <div class="caption">Click to preview document</div>
                                        </v-flex>
                                        <v-flex xs12 sm8 class="mt-10 mb-10">
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <div class="caption grey--text">Description</div>
                                                    <div>{{ props.item.documentDescription }}</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap class="mt-5">
                                                <v-flex xs12 sm4>
                                                    <div class="caption grey--text">Category</div>
                                                    <v-chip class="ml-0">
                                                        {{ props.item.categoryName }}
                                                    </v-chip>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <div class="caption grey--text">Type</div>
                                                    <v-chip class="ml-0">
                                                        {{ props.item.typeName }}
                                                    </v-chip>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm4>
                                                    <div class="caption grey--text">Created By</div>
                                                    <v-chip class="user-chip-container ml-0">
                                                        <v-avatar>
                                                            <v-img ref="avatar" :src="awsS3Helper.getAvatarUrl(props.item.createdBy.userId)"></v-img>
                                                        </v-avatar>
                                                        {{props.item.createdBy.firstName}} {{props.item.createdBy.lastName}}
                                                    </v-chip>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <div class="caption grey--text">Created On</div>
                                                    <div>{{ props.item.createdOn | moment('MMM DD, YYYY') }}</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm4>
                                                    <div class="caption grey--text">Version</div>
                                                    <v-chip class="ml-0">
                                                        {{ props.item.versionNumber }}
                                                    </v-chip>
                                                </v-flex>
                                                <v-flex xs12 sm4>
                                                    <div class="caption grey--text">Version Label</div>
                                                    <div>{{ props.item.versionLabel }}</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap v-if="props.item.versionNotes">
                                                <v-flex xs12 sm12>
                                                    <div class="caption grey--text">Version Notes</div>
                                                    <div>{{ props.item.versionNotes }}</div>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs12 sm4>
                                                    <div class="caption grey--text">Your Response</div>
                                                    <b :class="getReponseData(props.item.responseTypeId).color">{{ getReponseData(props.item.responseTypeId).description }}</b>
                                                </v-flex>
                                                <v-flex xs12 sm4 v-if="props.item.responseTypeId>0">
                                                    <div class="caption grey--text">Responded On</div>
                                                    <b>{{ props.item.responseDate | moment('MMM DD, YYYY h:mma') }}</b>
                                                </v-flex>
                                            </v-layout>
                                             <v-layout v-if="props.item.employeeRemarks" row wrap>
                                                <v-flex xs12 sm12>
                                                    <div class="caption grey--text">Your Remarks</div>
                                                    {{ props.item.employeeRemarks }}
                                                </v-flex>
                                            </v-layout>
                                        </v-flex>
                                    </v-layout>
                                    <v-divider v-if="props.item.responseTypeId==0"></v-divider>
                                    <v-card-actions v-if="props.item.responseTypeId==0" @click.stop>
                                        <v-spacer></v-spacer>
                                        <v-menu left v-model="menu_status[props.index]" offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-btn color="primary" dark v-on="on" :loading="loading_response[props.index]">
                                                    <span class="pr-5 pl-10">Select Response</span>
                                                    <v-icon v-show="!menu_status">arrow_drop_down</v-icon>
                                                    <v-icon v-show="menu_status">arrow_drop_up</v-icon>
                                                </v-btn>
                                            </template>
                                            <v-list dense>
                                                <v-list-tile @click="showResponseConfirmation(props.item, 1)">
                                                    <v-list-tile-title class="green--text" small>Acknowledge and Accept</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile @click="showResponseConfirmation(props.item, 2)">
                                                    <v-list-tile-title class="red--text" small>Acknowledge with Concern</v-list-tile-title>
                                                </v-list-tile>
                                                <v-list-tile @click="showResponseConfirmation(props.item, 3)">
                                                    <v-list-tile-title class="orange--text" small>Request Discussion</v-list-tile-title>
                                                </v-list-tile>
                                            </v-list>
                                        </v-menu>
                                        <!-- <v-chip class="getReponseData(props.item.responseTypeId).color" label>
                                            <b>{{ getReponseData(props.item.responseTypeId).description }}</b>
                                        </v-chip> -->
                                    </v-card-actions>
                                </v-card>
                            </td>
                        </tr>
                    </template>
                </v-data-table>  
                <v-card-text v-else class="ml-10">
                    No records found.
                </v-card-text>  
            </v-card>       
        </v-flex>

        <v-dialog v-model="dialogPreview" fullscreen hide-overlay transition="dialog-bottom-transition">
            <preview ref="refPreviewComponet" :dialogPreview.sync="dialogPreview"></preview>
        </v-dialog>
        <v-dialog v-model="dialogOkCancel2" persistent width="600">
            <ok-cancel :msg="dialogOkCancel2Msg" alignLeft="true" okLabel="Submit Response" :dialogOkCancel2.sync="dialogOkCancel2" @ok="submitResponse"></ok-cancel>
        </v-dialog>
    </v-layout> 
</template>

<script>

import edocumentsApi from '@/api/edocuments'
import awsS3Helper from '@/helpers/aws-s3'
import commonfn from '@/common/functions'   //for refactor
import rowsPerPageItems from '@/constants/rows-per-page'
import AWSS3DocumentType from '@/constants/aws-s3-document-types'
import pageKeys from '@/common/pagekeys'
import response_types from '@/constants/edoc-response-types'
import { getFileTypeIcon } from '@/helpers/file-color-icons'
import { getSort, getRowsPerPage, updateRowsPerPage, updateSort } from '@/helpers/user-prefs'

export default {     
    name: 'MyeDocuments',
    metaInfo: {
        title: 'My eDocuments',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'My eDocuments' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' }
        ]
    },
    components: {
        'preview': () => import('@/components/FilePreview/Preview'),
        'ok-cancel': () => import('@/components/BasicPopups/OkCancelWithComments')
    },
    data () {
        const routeName = this.$route.name
        const savedSort = getSort(routeName)

        return {
            awsS3Helper,
            getFileTypeIcon,
            rowsPerPageItems,
            commonfn,
            paginationSync: {
                rowsPerPage: getRowsPerPage(routeName),
                sortBy: savedSort.sortBy,
                descending: savedSort.descending,
            },
            search: null,
            menu_status: [],
            dialogPreview: false,
            dialogOkCancel2Msg: '',
            dialogOkCancel2: false,
            selectedResponseTypeId: null,
            selectedData: null,
            error: false,
            errorMessage: '',
            loading: false,
            loading_response: [],
            documents: []
        }
    },
    methods: {
        async showResponseConfirmation(data, responseTypeId){
            this.selectedData = data
            this.selectedResponseTypeId = responseTypeId

            this.dialogOkCancel2Msg = `You have selected <b class='${this.getReponseData(responseTypeId).color}'>${this.getReponseData(responseTypeId).label}</b>.<br><br>
                                        Do you want to proceed with submitting this response?
                                        This will be recorded for this document and cannot be changed once submitted.`
            this.dialogOkCancel2 = true
        },
        getReponseData(responseTypeId){
            return response_types.find(x => x.responseTypeId == responseTypeId)
        },
        async submitResponse(comment){
            try {
                const data = {
                    documentId: this.selectedData.documentId,
                    versionNumber: this.selectedData.versionNumber,
                    responseTypeId: this.selectedResponseTypeId,
                    responseTypeString: this.getReponseData(this.selectedResponseTypeId).description,
                    employeeRemarks: comment
                }
                const response = await edocumentsApi.submitResponse(data)
                if (response && response.status == 200) {
                    this.getMyEDocuments(false)
                }
            }catch(error){
                console.log(error)
                this.error = true
                this.errorMessage = error
            }
        },
        async preview(data) {
            const file = {
                name: data.versionLabel,
                type: data.fileType,
                url: '',
                downloadUrl: awsS3Helper.getCompanyDocumentUrl(
                    data.fileName,
                    AWSS3DocumentType.eDocuments
                )
            }

            const requiresSignedUrl = ['WordDocument', 'Pdf'].includes(data.fileType)

            if (requiresSignedUrl) {
                const response = await edocumentsApi.getPreSignedUrl({
                    fileName: data.fileName
                }, pageKeys.my_edocuments)

                if (!response || response.status !== 200) return

                file.url = response.data
            } else {
                file.url = file.downloadUrl
            }

            this.$refs.refPreviewComponet.setParams(file)
            this.dialogPreview = true
        },
        async getMyEDocuments(show_loading) {
            try {
                this.loading = show_loading
                const response = await edocumentsApi.getMyEDocuments()
                if (response && response.status == 200) {
                    this.documents = response.data.items
                }
                this.loading = false
            }catch(error){
                this.error = true
                this.errorMessage = error
            }
        },
    },
    async created() {
        //update header titles
        this.$root.$emit('setHeaderTitles', {
            display: true,
            headerTitle: '',
            headerPageTitle: 'My eDocuments'
        })

        this.getMyEDocuments(true)
    },
    watch: {
        'paginationSync.rowsPerPage'(newVal) {
            updateRowsPerPage(this.$route.name, newVal)
        },
        'paginationSync.sortBy'(newVal) {
            updateSort(this.$route.name, newVal, this.paginationSync.descending)
        },
        'paginationSync.descending'(newVal) {
            updateSort(this.$route.name, this.paginationSync.sortBy, newVal)
        }
    },
    computed: {
        searchLabel() {
            return this.isMobile ? 'Search' : 'Search Title, Description, Category, Type'
        },
        edocumentsFiltered() {
            let temp = this.documents

            // search handler
            if (this.search) {
                const searchLower = this.search.toLowerCase()

                temp = temp.filter(item => {
                    const titleMatch = item.documentTitle.toLowerCase().includes(searchLower)
                    const descriptionMatch = item.documentDescription.toLowerCase().includes(searchLower)
                    const categoryNameMatch = item.categoryName.toLowerCase().includes(searchLower)
                    const typeNameMatch = item.typeName.toLowerCase().includes(searchLower)
                   
                    return titleMatch || descriptionMatch || categoryNameMatch || typeNameMatch
                })
            }

            return temp
        },
    }
}
</script>
<style scoped>
.section-layout-mobile {
    padding:0px 20px 0px 20px;
}
</style>